const isValid = value => {
  return value !== undefined && value !== null && value !== '';
};
export default isValid;